/*
  C Inside Box: swaps the poster for the Shopify-hosted video (kept in a <template>
  so nothing downloads until the visitor presses play) and starts playback.
*/
if (!customElements.get('c-inside-box-video')) {
  customElements.define(
    'c-inside-box-video',
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.c-inside-box__play');
        this.template = this.querySelector('template');
        if (!this.button || !this.template) return;
        this.button.addEventListener('click', () => this.play(), { once: true });
      }

      play() {
        const video = this.template.content.querySelector('video')?.cloneNode(true);
        if (!video) return;
        this.button.remove();
        this.querySelector('img')?.remove();
        this.appendChild(video);
        this.classList.add('is-playing');
        video.play().catch(() => {});
        video.focus();
      }
    }
  );
}
